import React, { useEffect, useState } from 'react'
import { useSubscriptions, ISubscription } from '@/hooks/useSubscriptions'
import { MotionButton } from '@/components/ui/motion-button'
import { Badge } from '@/components/ui/badge'
import { priceForPlan } from '@/lib/priceConversions'
import { Receipt } from 'lucide-react'

function Subscriptions() {
  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(true)
  const { listSubscriptions, updateSubscription } = useSubscriptions()

  const getSubscriptions = async () => {
    setLoading(true)
    const subs = await listSubscriptions()
    setSubscriptions(subs)
    setLoading(false)
  }

  const cancelSubscription = async (subcription: ISubscription) => {
    const updatedSubscription = await updateSubscription({
      id: subcription.id,
      active: false,
    })
    if (updatedSubscription.status == 'non_renewing') {
      setSubscriptions((prev) =>
        prev.map((sub) =>
          sub.id === updatedSubscription.id ? updatedSubscription : sub
        )
      )
      // toast
    }
  }

  useEffect(() => {
    getSubscriptions()
  }, [])

  const renderUSD = (price) =>
  price.split('USD').map((part, index, arr) => (
    <React.Fragment key={index}>
      {part}
      {index < arr.length - 1 && (
        <span className="text-sm text-gray-500 mx-1">USD</span>
      )}
    </React.Fragment>
  ))

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-[500px]">
        <div className="animate-spin rounded-full h-14 w-14 border-4 border-primary border-t-transparent mb-4" />
        <p className="text-lg font-semibold text-gray-800 animate-pulse">Loading subscriptions...</p>
      </div>
    )
  }

  if (subscriptions.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[300px] text-center">
        <Receipt className="w-14 h-14 text-gray-300 mb-4" />
        <p className="text-lg font-semibold text-gray-700">No subscriptions found</p>
        <p className="text-sm text-gray-400 mt-1">You don't have any active subscriptions yet.</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col justify-center items-center space-y-4 w-full m-auto">
      <h1 className="text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
        Your Subscriptions
      </h1>
      <section aria-labelledby="order-heading" className="mt-10">
        <h3 className="sr-only">Items</h3>
        {subscriptions.map((subscription) => (
          <div
            key={subscription.id}
            className="flex grow flex-col items-start gap-x-2 rounded-md border
            border-solid border-neutral-border bg-default-background px-4 py-4 shadow-sm mb-2"
          >
            <div className="flex w-full flex-col items-start mb-2">
              <div className="flex w-full flex-col">
                <div className="flex justify-between w-full">
                  <span className="text-base font-semibold">
                    {subscription.name}
                  </span>
                  {/* <span>
                    {subscription.status === 'active' ? (
                      <Badge className="bg-green-600">Active</Badge>
                    ) : (
                      <Badge>Inactive</Badge>
                    )}
                  </span> */}
                </div>
              </div>
            </div>
            <div className="flex w-full flex-col items-start gap-2">
              {subscription.plans.map((plan) => (
                <div
                  className="flex-col w-full items-start gap-2"
                  key={plan.id}
                >
                  <div className="grow shrink-0">
                    {plan.id} - {plan.name}
                  </div>

                  <div className="">{renderUSD(priceForPlan(plan))}</div>

                  {/* <div className="flex justify-end w-full">
                    {plan.status === 'active' &&
                      !plan.id.startsWith('TECHNET') && (
                        <MotionButton
                          className="bg-red-600"
                          onClick={(
                            event: React.MouseEvent<HTMLButtonElement>
                          ) => {
                            event.preventDefault()
                            cancelSubscription(subscription)
                          }}
                          variant="secondary"
                          size="sm"
                        >
                          Cancel
                        </MotionButton>
                      )}
                  </div> */}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="flex justify-center w-full mt-4">
          <p>
            Please e-mail{' '}
            <a
              href="mailto:ctisupport@carquest.com"
              className="underline text-blue-700 hover:cursor-pointer"
            >
              ctisupport@carquest.com
            </a>{' '}
            if you would like to make a change to your subscriptions
          </p>
        </div>
      </section>
    </div>
  )
}

export default Subscriptions